module.exports = __webpack_public_path__ + "static/img/logo_sign_grey.092e33b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_sign_grey.svg
// module id = 1442
// module chunks = 0